export default __webpack_public_path__ + "static/about-ekko-bg-mobile-f47fe0a8fd7ffc361b89a8b201a355db.jpg";